export default __webpack_public_path__ + "static/portfolio_gallery_23-64104c62a78b091635185e29d3a9f81d.jpg";